function transformScreeningDataToFhir(screeningData) {
  const client = screeningData.client;

  const organization = {
    resourceType: "Organization",
    identifier: [{
      "system": "https://uniteus.com/",
      "value": screeningData.provider_id
    }]
  };

  const patient = {
    resourceType: "Patient",
    name: [
      {
        given: [client.first_name],
        family: client.last_name
      }
    ],
    birthDate: client.date_of_birth,
    telecom: [],
    identifier: [],
    contact: [
      {
        telecom: []
      }
    ]
  };

  if (client.medicaid_id) {
    patient.identifier.push({
      system: "http://www.medicaid.gov/",
      type: {
        coding: [
          {
            code: "MA",
            system: "http://terminology.hl7.org/CodeSystem/v2-0203"
          }
        ]
      },
      value: client.medicaid_id
    });
  }

  if (client.phone_number && client.phone_number.phone_number) {
    patient.telecom.push({
      system: "phone",
      value: transformPhoneNumber(client.phone_number.phone_number)
    });

    patient.contact[0].telecom.push({
      system: "phone",
      value: transformPhoneNumber(client.phone_number.phone_number)
    });
  }

  if (client.email_address) {
    patient.telecom.push({
      system: "email",
      value: client.email_address
    });
  }

  if (client.address && Object.keys(client.address).length > 0) {
    const address = client.address;
    const addressLines = [];
    if (address.line_1) addressLines.push(address.line_1);
    if (address.line_2) addressLines.push(address.line_2);

    let fhirAddress = {
      line: addressLines,
      city: address.city,
      state: address.state,
      postalCode: address.postal_code,
      country: address.country,
    };

    if (address.address_type == 'mailing') {
      fhirAddress.use = 'home';
      fhirAddress.type = 'postal';
    }
    else if (address.address_type == 'home' || address.address_type == 'work') {
      fhirAddress.use = address.address_type;
    }
    else {
      fhirAddress.use = 'temp';
    }

    Object.keys(fhirAddress).forEach(key => {
      if (fhirAddress[key] === undefined) {
        delete fhirAddress[key];
      }
    });

    patient.address = [fhirAddress];
  }

  const observations = screeningData.answers.map((answer, index) => {
    const observationId = `obs-${Date.now()}-${index}`;
    const observation = {
      resourceType: "Observation",
      id: observationId,
      status: "final",
      code: {
        coding: [
          {
            system: "http://example.org/fhir/CodeSystem/screening-questions",
            code: answer.loinc_code || "null",
            display: answer.title,
            id: answer.id
          }
        ]
      },
      valueCodeableConcept: {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem",
            code: answer.option?.loinc_code || "null",
            display: answer.option?.text,
            id: answer.option?.id
          }
        ]
      },
      effectiveDateTime: new Date().toISOString()
    };

    return observation;
  });

  return { organization, patient, observations };
}

function transformPhoneNumber(phone, countryCode = '+') {
  const pattern = /^\((\d{3})\)-(\d{3})-(\d{4})$/;
  const match = phone.match(pattern);

  if (match) {
    return countryCode + match[1] + match[2] + match[3];
  }
  return null;
}

function buildEncounterEntry(templateId) {
  return {
    fullUrl: `Encounter/`,
    resource: {
      resourceType: "Encounter",
      class: {},
      status: 'finished',
      meta: {
        extension: [
          {
            url: 'https://widget.uniteus.com/template/template_id',
            valueId: templateId
          }
        ]
      }
    },
  };
}

function buildConsentEntry(consentFileData) {
  return {
    fullUrl: `Consent/`,
    resource: {
      category: [{ coding: [{ code: "consent-id" }] }],
      dateTime: new Date().toISOString(),
      id: crypto.randomUUID(),
      resourceType: "Consent",
      scope: {
        coding: [{ "code": "treatment" }],
        text: "treatment"
      },
      sourceAttachment: {
        contentType: "application/pdf",
        data: consentFileData,
        title: "Consent PDF"
      },
      status: "active"
    }
  };
}

export default function createFhirBundle(screeningData, consentFileData, widgetSubmissionIds = []) {
  const { organization, patient, observations } = transformScreeningDataToFhir(screeningData);

  const bundle = {
    resourceType: "Bundle",
    type: "collection",
    id: crypto.randomUUID(),
    ...(widgetSubmissionIds.length > 0 && { widget_submission_ids: widgetSubmissionIds }),
    meta: {
      lastUpdated: new Date().toISOString(),
      profile: []
    },
    entry: [
      { fullUrl: `Organization/`, resource: organization },
      { fullUrl: `Patient/`, resource: patient },
      buildEncounterEntry(screeningData.template_id),
      buildConsentEntry(consentFileData),
      ...observations.map(obs => ({
        fullUrl: `Observation/${obs.id}`,
        resource: obs
      }))
    ]
  };

  return bundle;
}
